module.exports = __webpack_public_path__ + "img/375_banner.2d7c9bc9.png";